/** @format */
import { Directive, Input, TemplateRef } from '@angular/core';

/**
 * A marker directive used to tag the `ng-template` that wraps single search filter component.
 */
@Directive({
    selector: '[sisSearchFilter]',
    standalone: false,
})
export class SearchFilterDirective {
    /**
     * Optional title for sectioning the filter view.
     */
    @Input() subtitle?: string;

    constructor(public templateRef: TemplateRef<unknown>) {}
}
